import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  collections: Collections[];
  onSelect: (string) => void;
  selectedMediaCollection: string;
}

interface Collections {
  collectionName: string;
}

const MediaGridNavBar = ({
  collections,
  onSelect,
  selectedMediaCollection,
}: Props) => (
  <div className="mediaGridContainer-navBar">
    <ul className="mediaGridContainer-navBarList">
      {collections.map((collection) => {
        const { collectionName } = collection;
        return (
          <li
            key={`${collectionName}-navBarItem`}
            className={twMerge(
              'mediaGridContainer-navBarItem',
              selectedMediaCollection === collectionName && 'active'
            )}
            onClick={() => onSelect(collectionName)}
            onKeyDown={() => onSelect(collectionName)}
          >
            <span
              className={twMerge(
                'mediaGridContainer-navBarItemTitleContainer',
                selectedMediaCollection === collectionName && 'active'
              )}
            >
              <p className="mediaGridContainer-navBarItemTitle">
                {collectionName}
              </p>
            </span>
          </li>
        );
      })}
    </ul>
    <select
      className="mediaGridContainer-navBarDropdown"
      onChange={(ev) => onSelect(ev.target.value)}
      value={selectedMediaCollection}
    >
      {collections.map((collection) => {
        const { collectionName } = collection;
        return (
          <option
            key={`option-${collectionName}`}
            className="mediaGridContainer-navBarDropdownItem"
            value={collectionName}
          >
            {collectionName}
          </option>
        );
      })}
    </select>
  </div>
);

export default MediaGridNavBar;
